__webpack_require__.p = "/assets/mednytt/";